import { stringToEnum } from '@snap-types/models/common';

export enum VisualQuantityPerType {
  START = 'S',
  END = 'E',
}

export const visualQuantityPerTypeSchema = stringToEnum(VisualQuantityPerType);
